/**
 * Hook used in Content Manager bulk action for converting page to live doc.
 */

import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

const CONVERT_TO_LIVE_DOC_PAGE_LIMIT_CONFIG = 'confluence_bulk_convert_page_to_live_doc_limit';

// Default values for max number of pages that allowed to select
const DEFAULT_PAGE_TO_LIVE_DOC_SELECTION_LIMIT = 50;
// Default values for max number of pages that allowed to convert
const DEFAULT_PAGE_TO_LIVE_DOC_CONVERSION_LIMIT = 10;

export const getBulkConvertToLiveDocPageLimit = () => {
	const [selectionLimit, conversionLimit] = StatsigConfigurations.getNumberList(
		CONVERT_TO_LIVE_DOC_PAGE_LIMIT_CONFIG,
		[DEFAULT_PAGE_TO_LIVE_DOC_SELECTION_LIMIT, DEFAULT_PAGE_TO_LIVE_DOC_CONVERSION_LIMIT],
	);

	return {
		selectionLimit,
		conversionLimit,
	};
};
